var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 11.5C16.5 9.78739 15.6978 8.25286 14.4311 7.21733M17.1374 17.2574C18.6779 15.7479 19.6337 13.644 19.6337 11.3168C19.6337 6.72357 15.9101 3 11.3168 3C6.72357 3 3 6.72357 3 11.3168C3 15.9101 6.72357 19.6337 11.3168 19.6337C13.5829 19.6337 15.6374 18.7274 17.1374 17.2574ZM17.1374 17.2574L20.88 21",
    stroke: "currentColor",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.b9d4c216fe73dbf2a25ffd182a91da16.svg";
export { ForwardRef as ReactComponent };